import { Typography, Button, Paper, Chip } from '@mui/material';

interface StoryCardProps {
  tag: string;
  tagColor?: string;
  title: string;
  description: string;
  ctaLabel: string;
  ctaHref: string;
}

export function StoryCard({
  tag,
  tagColor = 'primary.main',
  title,
  description,
  ctaLabel,
  ctaHref,
}: StoryCardProps) {
  return (
    <Paper
      elevation={0}
      sx={{
        p: 4,
        height: '100%',
        bgcolor: 'white',
        border: '1px solid',
        borderColor: 'divider',
        borderRadius: 3,
        display: 'flex',
        flexDirection: 'column',
      }}
    >
      <Chip
        label={tag}
        size="small"
        sx={{
          bgcolor: tagColor,
          color: 'white',
          fontWeight: 600,
          mb: 2,
          alignSelf: 'flex-start',
        }}
      />
      <Typography variant="h5" fontWeight={700} sx={{ mb: 2 }}>
        {title}
      </Typography>
      <Typography
        variant="body2"
        color="text.secondary"
        sx={{ mb: 3, flexGrow: 1, lineHeight: 1.7 }}
      >
        {description}
      </Typography>
      <Button
        variant="text"
        href={ctaHref}
        sx={{
          alignSelf: 'flex-start',
          p: 0,
          '&:hover': { bgcolor: 'transparent', textDecoration: 'underline' },
        }}
      >
        {ctaLabel} →
      </Button>
    </Paper>
  );
}
